import React from 'react';
import { combineUrl } from '@agilepoint/utils-common';
import { ConfigSource } from '@agilepoint/wat';
import { IApplicationConfig } from 'types';

const configFilePath = combineUrl(process.env.PUBLIC_URL, `config.json?${new Date()}`);

export function useLoadConfig() {
    const [isLoading, setIsLoading] = React.useState(true);
    const [defaultConfig, setDefaultConfig] = React.useState<IApplicationConfig>({} as IApplicationConfig);
    const config = ConfigSource.fromFile<IApplicationConfig>(configFilePath);
    React.useEffect(() => {
        config.load().then((result: any) => {
            setDefaultConfig(result);
            setIsLoading(false);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return {
        isLoading,
        defaultConfig
    };
}
